import type { Infer } from 'superstruct';
import {
	array,
	enums,
	number,
	object,
	optional,
	size,
	string,
} from 'superstruct';

import {
	minimumValidatedArray,
	parsableInteger,
	stringDate,
	stringMaxLength,
	userStringWithMaxLength,
	withMessage,
} from '@adflow/shared/util-superstruct';

export const STRUCTURED_SNIPPET_HEADERS = [
	'Amenities',
	'Brands',
	'Courses',
	'Degree programs',
	'Destinations',
	'Featured hotels',
	'Insurance coverage',
	'Models',
	'Neighborhoods',
	'Service catalog',
	'Shows',
	'Styles',
	'Types',
] as const;

export type StructuredSnippetHeader =
	(typeof STRUCTURED_SNIPPET_HEADERS)[number];

export const STRUCTURED_SNIPPET_VALUES_MIN_VALID = 3;
export const STRUCTURED_SNIPPET_VALUE_MAX_LENGTH = 25;

export const ViewStructuredSnippetDto = object({
	id: number(),
	header: string(),
	values: array(string()),
	createdAt: stringDate(),
	updatedAt: stringDate(),
});

export const AddStructuredSnippetDto = object({
	id: optional(parsableInteger()),
	header: withMessage(
		enums([...STRUCTURED_SNIPPET_HEADERS]),
		'validations:Required'
	),
	values: minimumValidatedArray(
		size(array(stringMaxLength(STRUCTURED_SNIPPET_VALUE_MAX_LENGTH)), 0, 10),
		userStringWithMaxLength(STRUCTURED_SNIPPET_VALUE_MAX_LENGTH),
		STRUCTURED_SNIPPET_VALUES_MIN_VALID
	),
});

export type ViewStructuredSnippetDto = Infer<typeof ViewStructuredSnippetDto>;
export type AddStructuredSnippetDto = Infer<typeof AddStructuredSnippetDto>;
